module.exports = __webpack_public_path__ + "resources/a86cb8bba70acee3c4e074ed385b29dc.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/startertransformed.png
// module id = 222
// module chunks = 0